import Button from 'components/Button';

import styles from './styles.module.scss';

const SkipButton = ({ className = '', disabled, label, onClick, id }) => {
    return (
        <Button
            className={`${styles.button} ${className} ${styles.footerSkipBorder}`}
            data-click-type="button"
            disabled={disabled}
            id={id}
            label={label}
            onClick={onClick}
        />
    );
};

export default SkipButton;
